import * as React from 'react';
import classNames from 'classnames';
import ControlCheckboxWithLabel, { IControlCheckboxWithLabelProps } from '@/components/ui/ControlCheckboxWithLabel';
import './styles.scss';

export interface IListCheckboxesProps {
  items: (IControlCheckboxWithLabelProps & { className?: string })[];
  /** Layout */
  layout?: 'default' | 'horizontal';
}

const ListCheckboxes: React.FunctionComponent<IListCheckboxesProps> = (props) => {
  if (props.items.length === 0) {
    return null;
  }
  return (
    <ul
      className={classNames('list-checkboxes', {
        ['layout-default']: !props.layout || props.layout === 'default',
        ['layout-horizontal']: props.layout === 'horizontal',
      })}
    >
      {props.items.map((item, itemIndex) => (
        <li
          key={itemIndex}
          className={item.className}
        >
          <ControlCheckboxWithLabel {...item} />
        </li>
      ))}
    </ul>
  );
};

ListCheckboxes.displayName = 'ListCheckboxes';

export default ListCheckboxes;
